import React from 'react';
import styled from 'styled-components';
import BuilderExecutionDateRange from '../../../../../components/Builder/BuilderExecutionDateRange';
import FunnelDateKind from './FunnelDateKind';
import FunnelTimeWindow from './FunnelTimeWindow';
import TimeUnitMenu from '../../../../../components/Builder/BuilderFields/TimeUnitMenu';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderSelectedOptionsSelector,
  selectTimeUnits,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import { QueryType, TimeUnit } from '../../../../../utils/apollo/graphqlSchema';
import { setTimeUnit } from '../../../../../redux/slices/oldBuilder';

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  row-gap: 8px;
  flex-wrap: wrap;
`;

const ConversionTextContainer = styled.div`
  display: flex;
  column-gap: 4px;
`;

const FunnelDateRangeSettings = () => {
  const dispatch = useAppDispatch();

  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );
  const timeUnits = useAppSelector(selectTimeUnits);
  assertCondition(selectedOptions?.type === QueryType.Funnel);

  const { timeUnit } = selectedOptions;

  const handleChangeTimeUnit = (newTimeUnit: TimeUnit) => {
    dispatch(setTimeUnit({ newTimeUnit }));
  };

  return (
    <Container>
      <BuilderExecutionDateRange />
      <TimeUnitMenu
        value={timeUnit}
        timeUnits={timeUnits}
        onChange={handleChangeTimeUnit}
      />
      {/* two children are representing the same sentence, therefore put together*/}
      <ConversionTextContainer>
        <FunnelDateKind />
        <FunnelTimeWindow />
      </ConversionTextContainer>
    </Container>
  );
};

export default FunnelDateRangeSettings;
